/** Минимальная ширина таблиц сверки — горизонтальный скролл внутри карточки на узких экранах. */
export const reconciliationRunsTableClass = 'table-compact min-w-[32rem]';
export const reconciliationCasesTableClass = 'table-compact min-w-[44rem]';
export const reconciliationSuspenseTableClass = 'table-compact min-w-[40rem]';
export const reconciliationCostsTableClass = 'table-compact min-w-[44rem]';
export const reconciliationPoliciesTableClass = 'table-compact min-w-[52rem]';
export const reconciliationRunRowsTableClass = 'table-compact min-w-[44rem]';

export const reconciliationTableScrollClass = '-mx-1 min-w-0 overflow-x-auto px-1 sm:-mx-2 sm:px-2';
